/* eslint-disable react/no-children-prop */
/* eslint-disable react/no-array-index-key */
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import isEmpty from 'lodash/isEmpty';
import selectModal from 'store/modals/selectors';
import { MODAL_AGENT_DETAIL } from 'store/modals/modals';
import UserAgent from './components/UserAgent';
import { AgentsWrapper, Wrapper } from './styled';
import { selectAgentsSelected, SelectShowCloudAgents } from 'store/Agents/selectors';
import some from 'lodash/some';
import { Masonry } from 'masonic';
import { selectPage } from 'store/Filters/selectors';
import AgentDetail from '../../../AgentDetail';
import usePrevProps from 'Hooks/usePrevProps';

const UserAgents = ({ agents }) => {
  const showAgentDetail = useSelector((state) => selectModal(state, MODAL_AGENT_DETAIL));
  const agentsSelected = useSelector(selectAgentsSelected);
  const showCloudAgents = useSelector(SelectShowCloudAgents);
  const entity = showCloudAgents ? 'cloudAgents' : 'agents';
  const page = useSelector((state) => selectPage(entity, state));
  const [agentsList, setAgentsList] = useState(agents);
  const agentsToRender = agentsList.length > 0 ? agentsList.map((el) => ({ agent: el, selected: some(agentsSelected, { id: el.id }) })) : [];

  useEffect(() => {
    setAgentsList(agents);
  }, [page, agents]);

  const itemsCount = agentsToRender?.length;
  const prevItemsCount = usePrevProps(itemsCount);

  const removesCount = useRef(0);

  const gridKeyPostfix = useMemo(() => {
    if (!itemsCount || !prevItemsCount) return removesCount.current;
    if (itemsCount < prevItemsCount) {
      removesCount.current += 1;
      return removesCount.current;
    }

    return removesCount.current;
  }, [itemsCount, prevItemsCount]);

  if (isEmpty(agents)) return null;
  return (
    <Wrapper>
      {showAgentDetail && <AgentDetail /> }
      <AgentsWrapper>
        <Masonry
          key={ `${page}-${gridKeyPostfix}` }
          items={ agentsToRender }
          render={ UserAgent }
          columnGutter={ 35 }
          rowGutter={ 30 }
          columnWidth={ 350 }
          maxColumnCount={ 3 }
        />
      </AgentsWrapper>
    </Wrapper>
  );
};
export default UserAgents;
